module.exports = __webpack_public_path__ + "img/logo.9f097d10.png";